import { ConfigProvider } from "antd";
import "./App.css";
// import AboutUspage from "./sections/AboutUs/About";
import Banner from "./sections/Banner/Banner";
import Best from "./sections/Best/Section/Best";
import Bigpromopage from "./sections/Bigpromo/Bigpromo";
import FooterPage from "./sections/Footer/Sections/Footer";
import Header from "./sections/Header/";
import Main from "./sections/Main/";
import Recommend from "./sections/Recommed/Section/Recommend";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Contact from "./sections/contact/Contact";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Raleway",
          fontSize: 15,
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <div className="">
                  <Header />
                  <Main />
                  <Bigpromopage />
                  <Recommend />
                  <Best />
                  <Banner />
                  <FooterPage />
                </div>
              </div>
            }
          />
          <Route
            path="/contactus"
            element={
              <div>
                <Header />
                <Contact />
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
